import React from "react";
import styles from "./Card.module.css";
import type { cardProps } from "./types.props";

const Card: React.FC<cardProps> = ({
    title,
    icon,
    children,
    headerActions,
    className = "",
    ...rest
}) => {
    return (
        <section className={`${styles.card} ${className}`} {...rest}>
            {(title || icon || headerActions) && (
                <header className={styles["card-header"]}>
                    <div className={styles["card-title-container"]}>
                        {icon && (
                            <span className={styles["card-icon"]} aria-hidden="true">
                                {icon}
                            </span>
                        )}
                        {title && <h2 className={styles["card-title"]}>{title}</h2>}
                    </div>
                    {headerActions && (
                        <div className={styles["card-header-actions"]}>{headerActions}</div>
                    )}
                </header>
            )}
            <div className={styles["card-content"]}>{children}</div>
        </section>
    );
};

export default Card;
